(() => {
  const defaults = {
    completeTitle: "Free shipping activated",
    completeText: "Your parcel is already on its way.",
    thresholdTitle: "Free shipping from",
    remainingText: "Left until free shipping",
  };

  const moneyFormat = () => window.cartStrings?.money_format || "${{amount}}";

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(Math.max(0, Math.round(cents)), moneyFormat());
    }
    return (Math.max(0, cents) / 100).toFixed(2);
  };

  const clampProgress = (value) => Math.min(100, Math.max(0, value));

  const updateProgressBar = function (percent) {
    const progress = clampProgress(percent);
    const progressFill = this.querySelector(".progress");
    const progressTrack = this.querySelector(".cart_bar_w");

    if (progressFill) {
      progressFill.style.width = `${progress}%`;
    }

    if (progressTrack) {
      progressTrack.setAttribute("aria-valuenow", String(Math.round(progress)));
    }

    this.classList.toggle("cart_shipping_free", progress >= 100);
  };

  const updateProgressText = function (subtotal, threshold) {
    const message = this.querySelector(".free-shipping-message");
    if (!message) return;

    const copy = {
      completeTitle: this.dataset.bkFreeCompleteTitle || defaults.completeTitle,
      completeText: this.dataset.bkFreeCompleteText || defaults.completeText,
      thresholdTitle: this.dataset.bkFreeThresholdTitle || defaults.thresholdTitle,
      remainingText: this.dataset.bkFreeRemainingText || defaults.remainingText,
    };
    const thresholdLabel = this.dataset.feThreshold || formatMoney(threshold * 100);
    const remainingCents = Math.max(0, Math.round((threshold - subtotal) * 100));

    message.classList.remove("opacity-0");

    if (subtotal >= threshold) {
      message.innerHTML = `<strong>${copy.completeTitle}</strong><span>${copy.completeText}</span>`;
      return;
    }

    message.innerHTML = `<strong>${copy.thresholdTitle} ${thresholdLabel}</strong><span>${copy.remainingText} ${formatMoney(remainingCents)}</span>`;
  };

  const initProgress = function (orderCents) {
    const rate = this.dataset.bkFixedMarketThreshold === 'true' ? 1 : Number(window.Shopify?.currency?.rate || 1);
    const threshold = Number(this.dataset.feAmount || 0) * rate;
    const subtotal = Number(orderCents || 0) / 100;

    if (!threshold) return;

    this.dataset.order = String(orderCents || 0);
    this.setProgressBar((subtotal / threshold) * 100);
    this.setProgressBarTitle(subtotal, threshold);
  };

  const patchProgressElement = () => {
    const ProgressBar = customElements.get("free-ship-progress-bar");
    if (!ProgressBar || ProgressBar.prototype.__bkFreeShippingPatched) return false;

    ProgressBar.prototype.setProgressBar = updateProgressBar;
    ProgressBar.prototype.setProgressBarTitle = updateProgressText;
    ProgressBar.prototype.init = initProgress;
    ProgressBar.prototype.__bkFreeShippingPatched = true;

    document.querySelectorAll("free-ship-progress-bar").forEach((bar) => {
      bar.init(bar.dataset.order);
    });

    return true;
  };

  if (!patchProgressElement()) {
    customElements.whenDefined("free-ship-progress-bar").then(patchProgressElement);
  }
})();
